import { ImageCircle } from '$components'
import { Text } from '$components'
import { ElementType } from 'react'

export type StatusProps = {
  photo?: string | ElementType,
  name: string
}

export function Profile({ photo, name }: StatusProps) {
  const PhotoComponent = photo && typeof photo !== 'string' ? photo : null

  return (
    <div className="flex items-center gap-stack-tight">
      {photo && typeof photo === 'string' && (
        <ImageCircle
          image={photo}
          size="sm"
        />
      )}

      {PhotoComponent && (
        <div className="text-fg-subtle bg-bg-subtle p-stack-dense rounded-pill">
          <PhotoComponent className="size-4" />
        </div>
      )}

      <div className="text-ellipsis overflow-hidden">
        <Text
          type="s"
          className="truncate"
        >
          { name }
        </Text>
      </div>
    </div>
  )
}
